import { render } from "./SubscriptionWarning.vue?vue&type=template&id=5e45e3ae&scoped=true"
import script from "./SubscriptionWarning.vue?vue&type=script&lang=js"
export * from "./SubscriptionWarning.vue?vue&type=script&lang=js"

import "./SubscriptionWarning.vue?vue&type=style&index=0&id=5e45e3ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e45e3ae"]])

export default __exports__